// Module
var code = "<span\n    class=\"version-tooltip\"\n    item-version=\"{{ row.stats.version }}\">\n    {{ row.stats.versionLabel || row.stats.version || '-' }}\n</span>\n";
// Exports
module.exports = code;